var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bank-transfer-clip-path)",
    fill: "#4287CA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.714 29.948a2.264 2.264 0 0 0 0-4.527H11.133a2.264 2.264 0 0 0 0 4.527h1.697a.566.566 0 0 1 .566.566V41.83a.566.566 0 0 1-.566.566h-1.697a2.264 2.264 0 0 0 0 4.527h13.581a2.264 2.264 0 0 0 0-4.527h-1.698a.566.566 0 0 1-.565-.566V30.513a.566.566 0 0 1 .565-.565h1.698ZM49.613 29.948a2.264 2.264 0 0 0 0-4.527H36.032a2.264 2.264 0 0 0 0 4.527h1.697a.566.566 0 0 1 .566.566V41.83a.566.566 0 0 1-.566.566h-1.697a2.264 2.264 0 0 0 0 4.527h13.581a2.264 2.264 0 0 0 0-4.527h-1.698a.566.566 0 0 1-.566-.566V30.513a.566.566 0 0 1 .566-.565h1.698ZM7.375 17.657a2.263 2.263 0 0 0 1.38 4.051h43.461a2.264 2.264 0 0 0 2.128-1.471 2.264 2.264 0 0 0-.77-2.603L33.021 4.483a2.264 2.264 0 0 0-2.648-.159L7.488 17.498l-.113.159ZM54.14 50.32H6.605c-.625 0-1.131.506-1.131 1.132v5.658c0 .626.506 1.132 1.131 1.132H54.14c.625 0 1.132-.506 1.132-1.132v-5.658c0-.626-.507-1.132-1.132-1.132Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bank-transfer-clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.21 3.917h54.325v54.325H3.21z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransferIcon);
export default __webpack_public_path__ + "static/media/bank-transfer-icon.5fec6d90e0b2cad7c437eebdbff5b307.svg";
export { ForwardRef as ReactComponent };